import { render, staticRenderFns } from "./aside.vue?vue&type=template&id=2d389208&scoped=true&"
import script from "./aside.vue?vue&type=script&lang=js&"
export * from "./aside.vue?vue&type=script&lang=js&"
import style0 from "./aside.vue?vue&type=style&index=0&id=2d389208&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d389208",
  null
  
)

export default component.exports